import {BasePanelPageStyle} from "../../panels/BasePanelPage";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/src/decorators/Style";

export class InlineUserDashboardPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    paywallPage = {
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE,
    };

    @styleRule
    link = this.themeProps.PAYWALL_LINK;
}
